package com.eladfinish.bible.contest.screens.search.usecases.facts

import com.eladfinish.bible.contest.domain.catalog.toBookIndex
import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.SpecialSearchItem
import com.eladfinish.bible.contest.utils.addGershaimAndColon
import com.eladfinish.bible.contest.utils.gematriaWord
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toImmutableList

class MapSpecialSearchItemsToUiModelsUseCase {

    operator fun invoke(
        items: List<SpecialSearchItem>,
    ): ImmutableList<VerseUiModel> =
        items.filter { it.book.isNotBlank() }.mapIndexed { index, item ->
            VerseUiModel(
                id = "${item.book}_${item.chapter}_${item.verse}_$index",
                text = item.content.addGershaimAndColon(),
                source = "(${item.book} ${item.chapter}, ${item.verse})",
                highlightedRanges = persistentListOf(),
                bookIndex = item.book.toBookIndex(),
                chapterIndex = item.chapter.gematriaWord(),
                verse = item.verse,
            )
        }.toImmutableList()
}
